module.exports = __webpack_public_path__ + "media/images/web/footer-e97be3711d5de64e149adccf39cf5885.png";